import React from "react";

export const Concierge = {
    title: "Concierge",
    subTitleOne:
    <div>
        Tailored services and CFO advisory to address your business needs.
    </div>,
    description: " ",
    listHeader: "Package Includes",
    listElements: [
      "Premier Package +",
      "Quarterly Tax Estimates",
      "Cash flow management",
      "Monthly Financial Reporting",
      "Financial Planning & Analysis",
    ]
};



// WEBPACK FOOTER //
// ./src/components/Packages/constants/Concierge.constants.js